module.exports = __webpack_public_path__ + "media/notify-chime.d215363c.wav";